// 日本時間（UTC+9、夏時間なし）の日付の境目
const JST = 9 * 3600_000;
/** 'YYYY-MM-DD'（日本時間）のその日 0 時を UTC の ISO で返す */
export const jstDayStart = (ymd: string) => new Date(Date.parse(`${ymd}T00:00:00Z`) - JST).toISOString();
/** 'YYYY-MM-DD'（日本時間）の翌日 0 時 */
export const jstDayEnd = (ymd: string) => new Date(Date.parse(`${ymd}T00:00:00Z`) - JST + 86_400_000).toISOString();
/** ISO の日時 → 日本時間の 'YYYY-MM-DD' */
export const jstDate = (iso: string) => new Date(Date.parse(iso) + JST).toISOString().slice(0, 10);
/** 'YYYY-MM'（日本時間）の月の始まりと次の月の始まり */
export function jstMonthRange(ym: string) {
  const [y, m] = ym.split('-').map(Number) as [number, number];
  const next = m === 12 ? `${y + 1}-01` : `${y}-${String(m + 1).padStart(2, '0')}`;
  return { from: jstDayStart(`${ym}-01`), to: jstDayStart(`${next}-01`) };
}
export const isYmd = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s);
export const isYm = (s: string) => /^\d{4}-\d{2}$/.test(s);
